function TeamMember({ index, slug, fetchUrl }) {
  return {
    state: 'idle',
    isActive: false,
    index,
    slug,
    fetchUrl,

    activateItem($dispatch) {
      $dispatch('activate-item', {
        index,
        slug,
        fetchUrl,
      });
    },
  };
}

export default TeamMember;
